export default {
      id: "ar_portail_famille-usage",
      viewBox: "0 0 60 60",
      url: "../dist/images/" + "sprite.svg#ar_portail_famille-usage",
      toString: function () {
        return this.url;
      }
    }